var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"locale-changer"},_vm._l((_vm.getCountries),function(country,i){return _c('div',{key:i,on:{"click":function($event){return _vm.changeLan(country.language)}}},[_c('country-flag',{class:_vm.findActive(country.language),attrs:{"country":country.flag}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }